var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 8.482,
    cy: 8.482,
    r: 8.482,
    transform: "translate(0 0)",
    fill: "#400000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155896",
    "data-name": "Path 155896",
    d: "M17.185.542l4.192,10.213,10.634.993a.875.875,0,0,1,.776.957.889.889,0,0,1-.288.592h0L24.454,20.61l2.381,10.83a.892.892,0,0,1-.644,1.065.831.831,0,0,1-.656-.12L16.4,26.7,7.23,32.4A.841.841,0,0,1,6.057,32.1a.9.9,0,0,1-.1-.652h0L8.34,20.616.294,13.3a.908.908,0,0,1-.081-1.251.836.836,0,0,1,.6-.3l10.6-.987L15.609.536A.846.846,0,0,1,16.73.063a.927.927,0,0,1,.454.479Z",
    transform: "translate(-0.002 0.007)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27571",
    "data-name": "Rectangle 27571",
    width: 32.924,
    height: 32.776
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    width: 1,
    height: 1,
    patternTransform: "matrix(1, 0, 0, -1, 0, 67.779)",
    viewBox: "0 0 34.23 33.889"
  }, /*#__PURE__*/React.createElement("image", {
    preserveAspectRatio: "none",
    width: 34.23,
    height: 33.889,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAALsAAADpAAABWL/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAHkAfQMBIgACEQEDEQH/xACqAAEBAAMBAQAAAAAAAAAAAAAAAQMEBQYCAQEBAQEBAQEAAAAAAAAAAAAAAwQCAQUGEAABAgMHBAIDAQAAAAAAAAAAEQQgAxUBAjITFCRFEDEzNDASQCJEBREAAAMHBAIDAQAAAAAAAAAAAAEzMNHhApKiAxFxEoLBckAhQRMSAAAEAgcIAgMAAAAAAAAAAAABAgMR0SAxEjIzcwRBkaGxcpKidHEiIVET/9oADAMBAAIRAxEAAAD2vxr4vzezdaSfu60hutIbrSG60hutIbuzyehr408WXD8y9RLqoKgqCoKgvR5vS3x0sOXDmrUS6qCoKCoKgvS5nS3x0cOXDmrUS6qCoLfkW/I+nyPrp8rq7o8/DmwZ7VEuqgqCoKgqC9Xk9bdDn4M2DPaol1UFQVBUFQXrcjr7oc7BmwZ7VEuqgqCoKgqC9jjdjdDSw+iee+deicdedeiHnXoh516IedeiHnXoh53q7rVH/9oACAECAAEFAJ3+k7uzam8Km8Km8Km8Km8Km8Gb5zMuuPNEwwuPNEwwuPNEwwz/ADRMcM/zRMcM/wA0THDOsa5qMxGYjMRmIzEZjSxv9f/aAAgBAwABBQC7Jl23ciWZEsyJZkSzIlmRLJkq5ZbcwxTe9zDFO73LP06IJ1nd7mDognWf3l4Ip/eXgin97md9FnCzhZws4WcLOJ2av//aAAgBAQABBQCa+y5lRKiVEqJUSolRKiVEqJUSolRKiZ+3dex838Dr2Pm4917CxrEpx7r2FFhUWJTjndu5UWFRRYVOOd27lRYVFFhU415buVFgUUUWBRTjXlu6UWBRRRYFFOMeW7pYVFFhUU4t7bulhUUUWBRTi3tu6WFRRYVFOKe27tYVFFiU4p97fzcS8buLzrSuTSuTSuTSuTSuTSuTSuTSuTSuTSuTSuTSuTSuTSuTLv0z8D//2gAIAQICBj8AcSlyBJWoi+qaiP4GL4JkMXwTIYvgmQxfBMhi+CZDF8EyGoNblr+bC1p+qSgoqjqDuYvnT1XquB3MXzp6r1Vh3MVzp6r1lhzMVzp6n1lhzMVzp6n1lhzMVzp6n1lhcVPxtqjBKYRj8i8/2pmLz/amYvP9qZi8/wBqZi8/2pmLz/amYfsG7gLtWkpu7Yfmsf/aAAgBAwIGPwAjhs/Zi7xMXeJi7xMXeJi7xMXeJhECrURGE/BU2+sgnpKm3mEE9JU28wgnpKm3mJCekqbWYkJ6SptZqQmBNwsltOQqb3nIVN7zkKm95yFTe85CpvechU3vOQbtEjEKEDOsf//aAAgBAQEGPwCaThrxPTXWATugE7oBO6ATugE7oBO6ATugE7oBO6ATugE7oBO6ATugE7oD+3H8146+RPu36jJu36jJu36jJu36DJu36DJu36DJu36DJu36DJu36DL7N+gy+zfp5GX2b9PIy+zfp5GSaXFPNKZ/RlKZkEZ6TcEZ6TcEZ6TcEZ6TcEZ6TcEZ6TcEZ6TcEZ6TcEZ6TcEZ6TcEZ6TcEZ6TcEZ6TcEZ6TcOHE+fDTjoeuu3wf/Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image",
    transform: "translate(-150 -544)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27573",
    "data-name": "Rectangle 27573",
    width: 80,
    height: 80,
    transform: "translate(150 544)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_109048",
    "data-name": "Group 109048",
    transform: "translate(-1.912 -1.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155898",
    "data-name": "Path 155898",
    d: "M7.568.227A8.741,8.741,0,0,0,2.2,3.584,10.3,10.3,0,0,0,.16,10.391l0,35.148c0,4.2-.767,13.63,1.085,16.589,2.742,4.384,7.278,4.036,13.437,4.036l52.83,0c6.541-.044,7.152-4.292,7.151-10.317V11.864c0-3.383.009-4.787-1.562-7.278C69.823-.618,64.745.078,60.143.078c-4.365,0-50.556-.26-52.575.148ZM4.307,56.482c0,3.46.577,5.549,5.535,5.549H67.088c4.419,0,3.432-2.6,3.432-10.178,0-1.937-.388-1.7-2.887-3.707L56.565,39.1c-.9.7-1.835,1.418-2.734,2.23-.95.858-1.869,1.527-2.848,2.415-.91.826-1.815,1.494-2.851,2.408A22.139,22.139,0,0,1,45.2,48.474a7.187,7.187,0,0,0-1.487-1.657L36.146,38.6a34.746,34.746,0,0,0-3.114-3.314L18.415,45.478c-2.514,1.731-4.763,3.349-7.328,5.092l-5.572,3.9c-.959.682-1.207.5-1.208,2.016Zm0-5.774L26.415,35.377c1.164-.81,6.529-4.768,7.421-5.012l2.934,3.2c.625.638.9.837,1.447,1.49l7.445,8.12c1.275-.75,9.535-8.282,10.9-9.016l6.968,5.675c2.268,1.9,4.612,3.89,6.9,5.627.274-1.54.088-16.233.088-19.071,0-3.253.457-16.906-.44-18.782a8.038,8.038,0,0,0-2.154-2.466,6.513,6.513,0,0,0-3.994-.917h-48.2c-7.651,0-11.431-1.3-11.429,7.852q.005,19.316,0,38.633Z",
    transform: "translate(154.787 552.797)",
    fill: "#b31217",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    transform: "translate(197.201 562.995)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_109047",
    "data-name": "Group 109047",
    transform: "translate(-7.915 -9.594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_109046",
    "data-name": "Group 109046",
    transform: "translate(0.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_109045",
    "data-name": "Group 109045",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_109044",
    "data-name": "Group 109044",
    transform: "translate(-0.099 -0.115)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27570",
    "data-name": "Rectangle 27570",
    width: 34.23,
    height: 33.889,
    transform: "translate(-0.378 -0.359)",
    fill: "url(#pattern)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_155897",
    "data-name": "Path 155897",
    d: "M17.18.542l4.192,10.213,10.634.993a.875.875,0,0,1,.776.957.889.889,0,0,1-.288.592h0l-1.443,1.31A44.5,44.5,0,0,1,16.387,16.87,44.5,44.5,0,0,1,1.722,14.608L.284,13.3A.908.908,0,0,1,.2,12.053a.836.836,0,0,1,.6-.3l10.6-.987L15.6.536A.846.846,0,0,1,16.726.063a.927.927,0,0,1,.454.479Z",
    transform: "translate(0.008 0.007)",
    fill: "#ffd401"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image-icon.152a100eeaf2f44dc2a4e346bcb8c951.svg";
export { ForwardRef as ReactComponent };